import { render, staticRenderFns } from "./TabMenuMobile.vue?vue&type=template&id=0a19cc76"
import script from "./TabMenuMobile.vue?vue&type=script&lang=js"
export * from "./TabMenuMobile.vue?vue&type=script&lang=js"
import style0 from "./TabMenuMobile.vue?vue&type=style&index=0&id=0a19cc76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports